// extracted by mini-css-extract-plugin
export var content = "style-mod--content--ba94c";
export var headerBar = "style-mod--header-bar--d02be";
export var hiddenBestsellers = "style-mod--hidden-bestsellers--d60dc";
export var img = "style-mod--img--75818";
export var urlBox = "style-mod--url-box--9f9c8";